import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  button: {
    marginVertical: pixelDimensions(2),
    paddingVertical: pixelDimensions(2),
    backgroundColor: appColors.darkBlue,
  },
  buttonSmall: {
    alignSelf: 'flex-end',
    padding: pixelDimensions(1.5),
    marginBottom: pixelDimensions(2),
  },
  header: {
    paddingVertical: pixelDimensions(5),
    justifyContent: 'center',
    backgroundColor: Colors.indigo700,
  },
  input: {
    fontSize: pixelDimensions(4),
    width: '100%',
    backgroundColor: Colors.white,
    fontFamily: 'MMedium',
    paddingVertical: pixelDimensions(3),
    paddingHorizontal: pixelDimensions(12),
    marginBottom: pixelDimensions(2),
    borderColor: Colors.grey500,
    borderWidth: 1,
  },
  inputIcon: {
    fontSize: pixelDimensions(5),
    position: 'absolute',
    color: Colors.grey700,
    top: pixelDimensions(3),
    left: pixelDimensions(3),
  },
  inputIconEye: {
    left: undefined,
    right: pixelDimensions(3),
  },
  imageLogo: {
    marginVertical: pixelDimensions(10),
    alignSelf: 'center',
    height: pixelDimensions(20),
    width: pixelDimensions(20) * (75 / 22),
  },
  textButton: {
    textAlign: 'center',
    color: Colors.white,
    fontSize: pixelDimensions(6),
  },
  textSmall: {
    fontSize: pixelDimensions(3),
    color: Colors.orange700,
  },
  textTitle: {
    fontSize: pixelDimensions(5),
    color: Colors.white,
    textAlign: 'center',
  },
  viewBase: {
    flex: 1,
  },
  viewForm: {
    marginHorizontal: pixelDimensions(5),
  },
  textError: {
    alignSelf: 'center',
  },
});

export default styles;
